/*
 * @Description: 网关管理
 * @Author: ab
 * @Date: 2025-06-08
 * @LastEditTime: 2020-06-08 
 * @LastEditors: ab
 */
import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  /* ---------------------1.网关管理----------------------- */
  
  // 删除网关
  async delClientInfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ClientInfo/DeleteClientInfoAsync',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
 
  // 修改网关
  async updateClientInfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ClientInfo/UpdateClientInfoAsync',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取网关列表
  async clientInfoList(params) {
    let header = await mgr();
    return api({
      url: '/api/ClientInfo/GetClientInfoListAsync',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
 
};
